module.exports = __webpack_public_path__ + "static/media/BuilderBannerContent.007f5441.png";